/* tslint:disable no-console */

class DebugLogger {
  public notify(error: Error) {
    console.error(`DebugLogger (error): ${error.message} stack: ${error.stack}`);
  }

  public leaveBreadcrumb(message, data) {
    const line = `DebugLogger (breadcrumb) ${message}`;
    if (arguments.length > 1) {
      console.log(`${line}: ${JSON.stringify(data)}`);  // single line for easier grep-ing
    } else {
      console.log(line);
    }

    breadcrumbCheck(message);
  }

  public debug(message, data) {
    const line = `DebugLogger (debug) ${message}`;
    if (arguments.length > 1) {
      console.debug(`${line}: ${JSON.stringify(data)}`);  // single line for easier grep-ing
    } else {
      console.debug(line);
    }
  }

  public setUser(uid) {
    console.log(`DebugLogger: setUser ${uid}`);
  }

  public clearUser() {
    console.log('DebugLogger: clearUser');
  }
}

export const breadcrumbCheck = (message) => {
  if (message.length > 23) {
    console.warn(`breadcrumb to long: '${message}'`);
  }
};

export const debugLogger = new DebugLogger();
